/* eslint-disable */
import React, { useState, useEffect } from 'react';

function SagsListe({ sager, farve, tom }) {
  if (!sager || sager.length === 0) {
    return <div style={{ color: '#4b5563', padding: '12px 0', fontStyle: 'italic' }}>{tom}</div>;
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {sager.map(s => (
        <div
          key={s.id}
          style={{
            background: '#0f172a', borderRadius: 8, padding: '10px 14px',
            border: `1px solid ${farve}33`, cursor: 'pointer',
          }}
          onClick={() => window.open(`https://app.skilsmissevejen.dk/sager/${s.id}`, '_blank')}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#e2e8f0', fontWeight: 500 }}>{s.fornavn} {s.efternavn}</span>
            <span style={{ color: farve, fontWeight: 700, fontSize: 12 }}>
              {s.dage_til_deadline < 0
                ? `${Math.abs(s.dage_til_deadline)} dage over`
                : `om ${s.dage_til_deadline} dage`}
            </span>
          </div>
          <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
            {s.naeste_deadline_titel || s.type} · {s.sagsbehandler || 'Ingen'}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function DeadlineKommandocenterPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hent = () =>
      fetch('/api/os/sags-diagnostik/deadlines', { credentials: 'include' })
        .then(r => r.json())
        .then(setData)
        .catch(console.error)
        .finally(() => setLoading(false));
    hent();
    const interval = setInterval(hent, 120000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <div style={{ color: '#94a3b8', padding: 32 }}>Henter deadlines...</div>;
  if (!data)   return <div style={{ color: '#ef4444', padding: 32 }}>Fejl ved hentning</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
        {[
          { label: 'Forfalden',              val: (data.forfalden    || []).length, farve: '#ef4444' },
          { label: 'Kritisk (0-7 dage)',     val: (data.kritisk_7d   || []).length, farve: '#f59e0b' },
          { label: 'Kommende (8-30 dage)',   val: (data.kommende_30d || []).length, farve: '#3b82f6' },
          { label: 'Ingen deadline sat',     val: data.ingen_deadline || 0,          farve: '#6b7280' },
        ].map(k => (
          <div key={k.label} style={{
            background: '#0f172a', borderRadius: 12, padding: '16px 24px',
            border: `1px solid ${k.farve}33`, minWidth: 140,
          }}>
            <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 4 }}>{k.label}</div>
            <div style={{ fontSize: 32, fontWeight: 700, color: k.farve }}>{k.val}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
        <div>
          <div style={{ color: '#ef4444', fontWeight: 600, marginBottom: 12, fontSize: 14 }}>Forfalden</div>
          <SagsListe sager={data.forfalden} farve="#ef4444" tom="Ingen forfalden deadlines" />
        </div>
        <div>
          <div style={{ color: '#f59e0b', fontWeight: 600, marginBottom: 12, fontSize: 14 }}>Kritisk — inden for 7 dage</div>
          <SagsListe sager={data.kritisk_7d} farve="#f59e0b" tom="Ingen kritiske deadlines" />
        </div>
        <div>
          <div style={{ color: '#3b82f6', fontWeight: 600, marginBottom: 12, fontSize: 14 }}>Kommende — 8-30 dage</div>
          <SagsListe sager={(data.kommende_30d || []).slice(0, 10)} farve="#3b82f6" tom="Ingen kommende deadlines" />
        </div>
      </div>
    </div>
  );
}
